import { forwardRef, type TextareaHTMLAttributes } from 'react';

interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  helperText?: string;
  error?: string;
}

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ label, helperText, error, className = '', id, ...props }, ref) => {
    const uid = id || (label ? label.toLowerCase().replace(/\s+/g, '-') : undefined);
    return (
      <div className="space-y-1.5">
        {label && (
          <label htmlFor={uid} className="block text-sm font-medium text-gray-700 dark:text-gray-300">
            {label}
          </label>
        )}
        <textarea
          ref={ref}
          id={uid}
          className={`
            w-full px-3 py-2.5 text-sm rounded-lg border bg-white dark:bg-gray-900
            text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500
            transition-colors duration-150 resize-none
            border-gray-200 dark:border-gray-700
            hover:border-gray-300 dark:hover:border-gray-600
            focus:outline-none focus:ring-2 focus:ring-slate-900/20 dark:focus:ring-white/20 focus:border-slate-400 dark:focus:border-gray-500
            disabled:opacity-50 disabled:cursor-not-allowed
            ${error ? 'border-red-400 dark:border-red-500 focus:ring-red-500/20' : ''}
            ${className}
          `}
          {...props}
        />
        {error && <p className="text-xs text-red-500 dark:text-red-400">{error}</p>}
        {helperText && !error && <p className="text-xs text-gray-400 dark:text-gray-500">{helperText}</p>}
      </div>
    );
  }
);
TextArea.displayName = 'TextArea';
